<div class="question">
  <div class="md-form">
    <p [class]="{'required' : question.isRequired}" [innerHTML]="question.title"></p>
    <app-attachments [downloadOnly]="true"
                     [attachments]="question.attachments"
                     [downloadRoute]="downloadRoute">
    </app-attachments>

    <div class="file-field md-form" *ngIf="!downloading && !downloadError">
      <button type="button" mdbBtn class="btn-outline" *ngIf="!video"
              (click)="videoRecorder.showModal()" mdbWavesEffect>
        <span><i class="far fa-video"></i>&nbsp; Start Recording</span>
      </button>
      <button type="button" mdbBtn class="btn-outline" *ngIf="uploading" mdbWavesEffect disabled>
        <span><i class="fa fa-spinner fa-spin" aria-hidden="true"></i>&nbsp; Uploading video...</span>
      </button>
      <input [hidden]="true" #fileInput type="file" />
      <video #videoElement *ngIf="videoUrl" class="video-player" [class.hidden-video-player]="uploading">
        <source *ngIf="videoUrl" [src]="videoUrl">
      </video>
    </div>

    <div class="downloading-video" *ngIf="downloading">
      <div class="downloading-video-content">
        Your video will be available here shortly. <br />
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </div>
    </div>
    <div class="downloading-video" *ngIf="downloadError">
      <div class="downloading-video-content">
        <i class="far fa-exclamation-triangle download-error"></i> <br />
        Your video failed to load. Please refresh the page to try again.
      </div>
    </div>

    <div *ngIf="!downloading">
      <a href="javascript:void(0);" *ngIf="video || downloadError" (click)="openRemoveVideoModal()">Remove Video</a>
    </div>
    <mdb-error *ngIf="uploadError">There was an issue uploading your video. Please try again.</mdb-error>
  </div>
</div>

<app-video-recorder #videoRecorder [sectionText]="question.title" (videoCompleted)="setVideoData($event)"></app-video-recorder>


<div mdbModal #removeModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="removeVideo()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="removeModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Remove Video</h4>
        </div>
        <div class="modal-body">
          Are you sure you want to remove this video? If yes, you will need to record another video to proceed and complete this section.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" aria-label="Close" (click)="removeModal.hide()" mdbWavesEffect>No</button>
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Yes</button>
        </div>
      </div>
    </form>
  </div>
</div>
